/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PathologyStrictHttpResponse } from '../../pathology-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PathologyIdRevertToDraftPost$Params {
  id: string;
}

export function pathologyIdRevertToDraftPost(http: HttpClient, rootUrl: string, params: PathologyIdRevertToDraftPost$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, pathologyIdRevertToDraftPost.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as PathologyStrictHttpResponse<void>;
    })
  );
}

pathologyIdRevertToDraftPost.PATH = '/Pathology/{id}/RevertToDraft';
